
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useContext, useEffect, useState } from 'react';
import { Box, MenuItem, Select, Typography } from '@mui/material';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import { numberToCurrency } from 'shared/utils/NumberToCurrency';
import EditIcon from '@mui/icons-material/Edit';
import { useJourneyResultFormQuery } from '../../../entities/ApplicationForm/hooks/queries';
import { adaptParams } from '../../utils/getUserData';
import { useFormContext } from 'react-hook-form';
import { IFormInput } from '../../../app/providers/formValues/ui/FormDataProvider';
import { useResolutionQuery } from 'entities/Resolution/hooks/queries';
import { CoveragesCueParameter } from 'shared/api/assurant/quoteResponseTypes';
import { checkParamType } from '../../utils/checkParamType';

const EditableLiability = () => {
	const { defaultQuery, setInitialPayloadData, initialPayload } = useContext(FormDataContext);
	const [isEditing, setIsEditing] = useState(false);
	const { setValue: setFormValue } = useFormContext<IFormInput>();
	const query = useJourneyResultFormQuery();
	const resolutionQuery = useResolutionQuery();

	const urlSearchString = window.location.search;
	const params = new URLSearchParams(urlSearchString);
	const client_id: string = params.get('client_id') || localStorage.getItem('client_id') || "";
	const type: string = params.get('type') || checkParamType(client_id) || "";

	const [liabilityOptions, setLiabilityOptions] = useState<CoveragesCueParameter | undefined>();

	const data = query && adaptParams(query.coverage_info.parameters);
	const belongingChosen = data?.personalPropertyAmount;

	const liabilityChosen = initialPayload?.coverage.parameters.find(
		(item) => item.name === 'liabilityAmount'
	);

	useEffect(() => {
		setFormValue('belongings', Number(belongingChosen));
	}, [setFormValue, query]);

	// Initialize liability options based on type
	useEffect(() => {
		if (defaultQuery) {
			const liability_Options: any = defaultQuery.coveragesCue.parameters.find(
				(item) => item.name === 'personalLiabilityOptions'
			);
			let result = [];
			if (type && type === 'anonymous') {
				// Anonymous users see all options
				result = liability_Options?.value ?? [];
			} else {
				// Non-anonymous users only see their chosen option
				result = liability_Options?.value
					? liability_Options?.value.filter((option: number) => option == liabilityChosen?.value)
					: [];
			}
			setLiabilityOptions({
				name: "personalLiabilityOptions",
				value: result,
			});
		}
	}, [defaultQuery, type, liabilityChosen?.value]);

	// Handle resolution query - filter out $300,000 if denied
	useEffect(() => {
		const liability_Options = liabilityOptions?.value;
		if (
			(resolutionQuery?.outcomeName === 'Denied') &&
			liability_Options && Array.isArray(liability_Options)
		) {
			const result = liability_Options.filter((option) => option !== 300000);
			setLiabilityOptions({
				name: "personalLiabilityOptions",
				value: result,
			});
		}
	}, [resolutionQuery, liabilityOptions]);

	const handleEdit = () => {
		setIsEditing(true);
	};

	const options = Array.isArray(liabilityOptions?.value) ? liabilityOptions.value : [];
	const currentValue = liabilityChosen?.value || '';

	const handleChange = (event: { target: { value: string | number } }) => {
		const newValue = event.target.value;
		setFormValue('liability', newValue.toString());
		setInitialPayloadData((prevState) => {
			if (!prevState) return prevState;
			const newParametersData = prevState.coverage.parameters.map((item) => {
				if (item.name === 'liabilityAmount') {
					return { ...item, value: newValue };
				}
				return item;
			});
			return {
				...prevState,
				coverage: {
					parameters: newParametersData,
				},
			};
		});
		setIsEditing(false);
	};

	if (isEditing) {
		return (
			<Select
				value={currentValue}
				onChange={handleChange}
				onBlur={() => setIsEditing(false)}
				autoFocus
				size="small"
				sx={{ fontWeight: 700 }}
			>
				{options.map((option: number) => (
					<MenuItem key={option} value={option.toString()}>
						{numberToCurrency(option)}
					</MenuItem>
				))}
			</Select>
		);
	}

	return (
		<Box
			display="flex"
			alignItems="center"
			gap={1}
			onClick={handleEdit}
			sx={{ cursor: 'pointer' }}
		>
			<EditIcon fontSize="inherit" />
			<Typography fontWeight={700} textAlign="right">
				{numberToCurrency(Number(currentValue))}
			</Typography>
		</Box>
	);
};

export default EditableLiability;
